import axios from "axios";
import { config, getDomain, tempAlErr, tempAlWait } from "../helpers"
import { alertIndex } from "../helpers/alertIndex";
import { IDTT_GET, IDTT_SET } from "./action-types";

// Mise à jour de l'identité
export function saveIdentite({
    logo,
    name,
    desc,
    slug
}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let isNext = false;

        axios.post(`${getDomain()}api/identite/set`, {
            logo: logo,
            name: name,
            description: desc,
            slug: slug,
            userId: localStorage.getItem('userId'),
            credentials: localStorage.getItem('userCred')
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    isNext = true;
                }

                dispatch({
                    type: IDTT_SET,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("idse005");
                dispatch({
                    type: IDTT_SET,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
    }
}

// Obtenir l'identité
export function getIdentite() {
    return function (dispatch) {
        let alert = tempAlWait();
        let datas = null;

        axios.post(`${getDomain()}api/identite`, {}, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    datas = res.datas;
                    localStorage.setItem('idttLogo', datas.logo);
                    localStorage.setItem('idttName', datas.name);
                    localStorage.setItem('idttDesc', datas.desc);
                    localStorage.setItem('idttSlug', datas.slug);
                }

                dispatch({
                    type: IDTT_GET,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("idge002");
                dispatch({
                    type: IDTT_GET,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
    }
}